var showdown  = require('showdown')
import React, {Component} from 'react';
import Link from 'gatsby-link'
import styled from "styled-components"

const tutorial_markdown = `
### TUTORIAL

#### Table of contents

- [What You Need](#whatyouneed)
- [EthScribe App](#ethscribeapp)
- [How to Enter Scribe](#howtoenterscribe)
- [How to Pay](#howtopay)
- [Payment Order Confirmation](#paymentorderconfirmation)
- [Searching Scribes](#searchingscribes)
- [View Details](#viewdetails)

#### What You Need

##### Major Credit Card
To post a Scribe to the Ethereum Blockchain you need a credit card. All major credit cards are accepted.

##### E-mail Address
A valid E-mail address is needed so the payment receipt and Scribe certificate can be emailed to you.


#### EthScribe App

To start, go to the [EthScribe App](https://app.ethscribe.com). EthScribe is a web application that is available on all 
mobile, tablet and desktop internet browsers.

#### How to Enter Scribe

To start go to __Scribe__ page.
If you are not in [Scribe](https://app.ethscribe.com) page, you can click on the __Scribe__  button in the application 
toolbar.

The Scribe page looks like this:

> !["Enter Scribe"](../static/tutorial/notes.png "Enter EthScribe")

Enter your Scribe in the __Enter your message here__ field.
> _Note: as you are typing the text the character count gets updated._

Some foreign language characters are counted as 2 characters, each emoji adds 4 to the character count.
When a Scribe reaches the limit of 140 characters the additional typing is ignored. 
Click the __Pay With Card__ button when you are ready to submit a Scribe.


#### How to Pay

Here is the payment form:

> <img src="../static/tutorial/pay.png" width=250 style="padding: 20px;"/>

Fill in all the form fields. E-mail address, credit card number, credit card expiration date, CVC fields are required, 
and optionally you can check the __Remember me__ checkbox. __Remember me__ makes it faster to submit your Scribe next 
time. Click the __Pay__ button when ready to finalize your Scribe purchase.

If all credit information is correctly entered the payment system validates the credit card and shows that the payment 
has been approved. If there is an error in the payment form the field in error is highlighted. Please correct the input 
and click __Pay__ again.



#### Payment Order Confirmation

After payment is complete the order confirmation is shown. You can your save order number for your reference. 
The order number may be used to retrieve all information about the Scribe.


#### Searching Scribes

To browse and search Scribes, use the Search page. To go to the search page click on the toolbar Search button. Enter a 
search term into the search input box and when submit search. The search results, Results are ordered by date, the most 
recent Scribes appear first.

> _Note: depending on the search term, the search result may have a large number of Scribes. Try to use a more specific 
search terms to reduce the number of returned search results._


##### Exact Search

The search term may contain a specific single word or a few words. all of the Scribes that contain at least one of the 
words in a search term will appear in the search results.

If multiple words are surrounded by double quotes (example: "hello there") then only the Scribes that contain the full 
quoted phrase (example: "hello there") will show.




##### Wildcard search

Search terms may contain a wildcard character (*). Wildcard character match any word, or part of the word.

If the search term is just a wildcard '' then any Scribe will match the search term. The Recents button is the shortcut 
for wildcard search (*) which returns all Scribes.

To match the part of the word use add wildcard at the end. For example to "th*" will return all Scribes that contain 
words that start with "th" (such as the, that, this, they, though, …)

#### View Details

To see Scribe Ethereum Blockchain details click the Ethereum icon (🔷)

> <img src="../static/tutorial/search.png" />

The **"Transaction Block"** links to the Ethereum Blockchain block that the transaction is part of.

> <img src="../static/tutorial/transaction.png" />

View the transaction block in Etherscan (one of the public Ethereum browsers).

> <img src="../static/tutorial/ethscan.png" />

The __"Transaction Hash"__ links  directly to a transaction.

> <img src="../static/tutorial/ethscanhash.png" />

Click __"Convert To ASCII"__ button at the bottom of the page to see Scribe.
> _Note: When a Scribe is show on the Etherscan site, some foreign language characters or emoji might not be readable in 
ASCII format._

`


class Tutorial extends Component {
    constructor(props, context) {
        super(props, context);

        var converter = new showdown.Converter(),
            html      = converter.makeHtml(tutorial_markdown);

        this.state = { html }
    }

    render() {
        return(
        <BodyContainer>
            <div dangerouslySetInnerHTML={{__html: this.state.html}} />
        </BodyContainer>
        )
    }

}

export default Tutorial


const BodyContainer = styled.div`
  max-width: 680px;
  margin: 0 auto;
  padding-top: 40px;
  
  @media screen and (max-width:680px) {
    margin-left: 10px;
    margin-right: 10px;
  }
  
    
  a {
        color: rgba(0, 0, 0, 0.54);
        text-decoration: none;
   }
    
    a:hover {
	  -webkit-stroke-width: 5.3px;
      -webkit-stroke-color: #FFFFFF;
      -webkit-fill-color: #FFFFFF;
      text-shadow: 1px 0px 30px green;
    }
    
    img {
      border-left: solid 5px lightgrey;
    }
    
    iframe {
        width: auto;
        height: auto;
        width:650px;
        height:366px;
        @media screen and (max-width:680px) {
            width: calc(100vw * 0.95);
            height: calc(100vw * 0.56);
        }
    
    
  }
  
  
`





// WEBPACK FOOTER //
// ./src/components/Tutorial/index.js